import { useState, useEffect, useCallback } from 'react';
import { useDubs } from '../provider';
import type { GameDetail, QueryResult } from '../types';

export function useGame(gameId: string | null): QueryResult<GameDetail> {
  const { client } = useDubs();
  const [data, setData] = useState<GameDetail | null>(null);
  const [loading, setLoading] = useState(!!gameId);
  const [error, setError] = useState<Error | null>(null);

  const fetchData = useCallback(async () => {
    if (!gameId) return;
    setLoading(true);
    setError(null);
    try {
      const game = await client.getGame(gameId);
      setData(game);
    } catch (err) {
      setError(err instanceof Error ? err : new Error(String(err)));
    } finally {
      setLoading(false);
    }
  }, [client, gameId]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { data, loading, error, refetch: fetchData };
}
